var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`las ${_vm.icon}`,style:({color: _vm.color,fontSize: `${_vm.size}px`})})
}
var staticRenderFns = []

export { render, staticRenderFns }